import theme from '../../muiTheme';

const styles = {


    rootContainer: {
        width: '100vw',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to right, #b24592, #f15f79)',
    },
    backgroundImageContainer: {
        position: 'fixed',
        minWidth: '100%',
        //maxHeight: '70vh',
        //height: '70vh',
        top: '80px',
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
        //borderRadius: '20px',
        [theme.breakpoints.down('sm')]: {
            height: '450px',
            minWidth: 'auto',
            maxHeight: '70vh',
            top: '65px',
            //borderRadius: '0px',
        }
    },
    backgroundImage: {
        //position: 'fixed',
        minWidth: '100%',
        //height: '100%',  
        //borderRadius: '20px',
        [theme.breakpoints.down('sm')]: {
            height: '100%',
            minWidth: 'auto',
        }
    },
    backgroundImageBlur: {
        position: 'fixed',
        minWidth: '100%',
        //maxHeight: '450px',
        top: '0px',
        filter: 'blur(5px)',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        }
    },

    backgroundQuoteContainer: {
        position: 'fixed',
        // minWidth: '100%',
        //maxHeight: '70vh',
        height: '70vh',
        top: '1vh',
        //boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
        //borderRadius: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px 40px',
        maxWidth: '700px',
        [theme.breakpoints.down('sm')]: {
            height: '390px',
            top: '40px',
            //borderRadius: '0px',
        },
    },

    backgroundQuote: {
        fontSize: '1.0rem',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.9rem',
        },

    },
    headerContainer: {
        position: 'sticky',
        top: 'calc(-100vh + 145px)',
        zIndex: '500',
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        boxSixing: 'border-box',
        background: 'transparent',
        [theme.breakpoints.down('sm')]: {
            top: '-725px',
            height: '850px'
        }
    },
    headerInfoContainer: {
        width: '100%',
        height: '300px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxSixing: 'border-box',
        background: 'white',
        zIndex: '1'
    },
    innerHeaderInfoContainer: {
        width: '100vw',
        maxWidth: '1000px',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        //border: '2px solid purple'
    },

    headerInfo: {
        display: 'flex',
        height: '100%',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginLeft: '20px'
    },

    headerAvatarContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
    },

    headerDetailsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-end'
    },

    headerDetails: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginBottom: '20px'
    },

    followNotification: {
        borderRadius: '15px',
        background: theme.palette.lightGray,
        color: 'white',
        padding: '2px 15px',
        margin: '5px 0px'
    },

    headerFollowMetrics: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginBottom: '20px'
    },
    userAvatar: {
        borderRadius: '150px',
        width: '150px',
        height: '150px',
        backgroundColor: 'black',
        border: '10px solid white',
        boxSizing: 'content-box',
        marginTop: '-75px',    
    },
    tabsAvatar: {
        borderRadius: '150px',
        width: '40px', 
        height: '40px',
        marginTop: '0px', 
        marginRight: '20px'   
    },
    tabsContainer: {

        width: '100%',
        height: '60px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        position: 'sticky',
        top: '185px',
        marginTop: '-1px',
        zIndex: '1'
    },
    swiperContainer: {
        width: '100%',
        maxWidth: '700px',
        height: 'auto',
        minHeight: '800px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        //border: '2px solid green',
        marginTop: '100px',
        marginBottom: '100px',
        zIndex: '1'
    },
    profileSwiper: {
        width: '100%',
    },
    swiperSlide: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    swiperSlideContentBox: {
        width: '100%',
        maxWidth: '700px',
        minHeight: '800px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',

    },
    popUpOverlay: {
        width: '100vw',
        height: '100vh',
        // top: '0px',
        // left: '0px',
        // position: 'fixed',
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '0px !important' //not a fan of !important but keeps being overidden by mui5 stack somewhere in their module
    },
    popUpBox: {
        zIndex: 1200,
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#00000094',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }

}

export default styles; 